import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=0c70a75a&"
import script from "./TheHeader.vue?vue&type=script&lang=js&"
export * from "./TheHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jogg/jogg-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c70a75a')) {
      api.createRecord('0c70a75a', component.options)
    } else {
      api.reload('0c70a75a', component.options)
    }
    module.hot.accept("./TheHeader.vue?vue&type=template&id=0c70a75a&", function () {
      api.rerender('0c70a75a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/TheHeader.vue"
export default component.exports